/**
 * S-19 Store SKU emblems (V5-owned — screen-local composition lives in the
 * feature dir; the design system stays foundation-owned). Mirrors the stroke
 * conventions of design/icons.tsx: 24 viewBox, currentColor, 1.8.
 */
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function base(props: IconProps) {
  return {
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    ...props,
  } as const;
}

/** Berserker — the flame. */
export function IconFlame(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 3c1 3-3 4.5-3 8a3 3 0 0 0 6 0c0-1.2-.6-2.2-1.2-3" />
      <path d="M12 3c4 3.5 7 6.6 7 11a7 7 0 0 1-14 0c0-2.5 1.2-4.6 2.6-6.4" />
    </svg>
  );
}

/** Boost — the bolt. */
export function IconBolt(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M13 2 4.5 13.5H11L9.5 22 19 10h-6.5L13 2Z" />
    </svg>
  );
}

/** Crush — the sincere star. */
export function IconStar(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="m12 3 2.7 5.7 6.3.8-4.6 4.3 1.2 6.2L12 17l-5.6 3 1.2-6.2L3 9.5l6.3-.8L12 3Z" />
    </svg>
  );
}

/** Match Extend — buying time. */
export function IconHourglass(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M6 3h12" />
      <path d="M6 21h12" />
      <path d="M8 3v3.5c0 2.5 4 4 4 5.5s-4 3-4 5.5V21" />
      <path d="M16 3v3.5c0 2.5-4 4-4 5.5s4 3 4 5.5V21" />
    </svg>
  );
}

/** Premium — the crown of the snob filter. */
export function IconCrown(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="m4 8 3.5 4L12 5l4.5 7L20 8l-1.4 10H5.4L4 8Z" />
      <path d="M5.4 18h13.2" />
    </svg>
  );
}
